// @flow
import type { csvData, csvType } from '../pages/upload/UploadViewer';

const add = (accumulator: string, currentValue:string) => accumulator.concat(currentValue);

export type pair = { key: string, value: string, regex: ?RegExp }
export type pairs = { [string]: pair }
export type stringObject = {[string]: string}
export type schemeType = {
    id: string,
    category: string,
    name: string,
    matches: stringObject
}
export type schemesType = Array<schemeType>

export function compare(accumulator:boolean, currentValue: boolean) {
  return (accumulator === currentValue) ? accumulator : true;
}

const csvRowAsMappedObject = (csvItem, mapping): stringObject =>
  Object.entries(mapping).reduce((result, item: any) =>
    Object.assign({ ...result }, { [item[0]]: csvItem[item[1].key] }), {});

const reduceObjectValues = (arr: Array<any>, reducer: (string, string) => any) =>
  arr.reduce(reducer);

export const lastValue = (item: stringObject): string =>
  reduceObjectValues(Object.values(item), (a: string, c: string) => c);

const hasValues = (item: stringObject): boolean =>
  reduceObjectValues(Object.values(item), add).length > 0;

export const getData = (mapping: pairs, csv: csvType): Array<stringObject> =>
  csv.filter((item: stringObject) => hasValues(item))
    .map(item => csvRowAsMappedObject(item, mapping));

export function getEmptyMapping(fields: Array<string>): pairs {
  const mapping: pairs = {};
  fields.forEach((name) => {
    mapping[name] = { key: '', value: '', regex: null };
  });
  return mapping;
}

export function testRegex(field: pair): boolean {
  if (field.regex) {
    const result = field.regex.test(field.value);
    return result;
  }
  return true;
}

export const isDisabled = (mandatory: Array<string>, all: Array<string>, mapping: pairs): boolean =>
  mandatory.map((item: string) => mapping[item].value === '')
    .concat(all.map(field => !testRegex(mapping[field])))
    .reduce(compare);

export const isRequired = (name: string, mapping: pairs, depends: {[string]: string}): boolean =>
  Object.keys(depends).indexOf(name) !== -1 && mapping[depends[name]].value === '';

export const getItemsFromCSV = (csv: csvData): any => (csv.data.length > 0 ?
  Object.keys(csv.data[0]).map((item: string) =>
    ({ label: item, value: item, disabled: false })) : []);


export function updateMapping(mapping: pairs,
  field: string,
  value: string,
  csvValue: string,
  countryCode: string,
  normalize: (string, string, string) => string,
  getRegex: (string, string) => RegExp,
) {
  const clone = { ...mapping };
  const item = { ...clone[field] };
  item.key = value;
  item.value = normalize(field, countryCode, csvValue);
  item.regex = getRegex(field, countryCode);
  clone[field] = item;
  return clone;
}

export function setDisabledItem(value: string, list: Array<any>, lastItem: any): Array<any> {
  const items = lastItem ? setDisabledItem(lastItem.key, list) : list;
  const idx = items.findIndex(o => o.label === value);
  const item = { ...items[idx] };
  item.disabled = !!lastItem;
  return items.fill(item, idx, idx + 1);
}
